<template>
  <div :class="['upload-file', 'upload-' + size]">
    <i @click="delVideo" title="删除视频" v-if="videoUrl" class="iconwrong delicon"></i>
    <el-upload
      class="el-upload-self"
      ref="video"
      :auto-upload="false"
      action=""
      :limit="1"
      :show-file-list="false"
      :on-change="handleVideoFile"
      accept=".mp4"
    >
      <video controls v-if="videoUrl" :src="videoUrl" :class="['video-position', 'video-' + size]"></video>
      <div :class="['video-' + size]" style="color:#8c939d;font-size: 22px" >
        视频上传
      </div>
    </el-upload>
    <span style="font-size: 12px;color: #cccccc">
      <font>支持扩展名：.MP4,视频比例：16:9,视频大小建议小于5MB</font>
    </span>
  </div>
</template>

<script>
import { Message } from 'element-ui'
export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "small",
      validator: function(value) {
        // 这个值必须匹配下列字符串中的一个
        return ["mini", "small", "middle"].indexOf(value) !== -1;
      }
    }
  },
  data() {
    return {};
  },
  computed: {
    videoUrl() {
      if (this.value) {
        return this.$store.state.oldStore.imgSrc +
          this.value +
          "&token=" +
          this.$store.state.oldStore.token;
      }
      return ''
    }
  },
  methods: {
    delVideo() {
      this.$refs.video.clearFiles();
      this.$emit("input", "");
    },
    async handleVideoFile(file) {
      let sizePass = await checkSize(file.raw);
      if (sizePass) {
        let fileName = await this.upload(file.raw);
        if (fileName) {
          this.$emit("input", fileName);
        } else {
          this.$emit("input", '');
        }
      } else {
        this.$refs.video.clearFiles();
      }
    },
    async upload(file) {
      const formData = new FormData();
      formData.append("file", file);
      let res = await this.$http.file(formData);
      return res.data.success && res.data.fileName;
    }
  }
};
function checkSize(file) {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    let size = 16/9;
    reader.onload = function(e) {
      let video = document.createElement('video')
      video.src = e.target.result;
      video.load()
      video.onloadedmetadata = function() {
        if (video.videoWidth/video.videoHeight != size) {
          Message.error("视频比例错误");
          resolve(false)
        } else {
          resolve(true)
        }
      };
    };
    reader.readAsDataURL(file);
  });
}
</script>

<style lang="less">
.upload-file {
  position: relative;
  &.upload-small {
    width: 288px;
  }
  &.upload-middle {
    width: 355px;
  }
  .delicon {
    color: #ff7c7c;
    font-weight: normal;
    position: absolute;
    right: 5px;
    top: 5px;
    cursor: pointer;
    font-size: 16px;
    transition: all 0.3s;
    z-index: 1;
  }
  .el-upload-self {
    border: 1px dashed #ccc;
  }
  .video-position {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  .video-small {
    width: 288px;
    height: 162px;
    line-height: 162px;
    text-align: center;
  }
  .video-middle {
    width: 355px;
    height: 200px;
    line-height: 200px;
    text-align: center;
  }
}
</style>
